export enum UserValidationErrors {
    "UserCode" = '_UserCodeAlreadyExists_',
    "UserName" = '_UserNameAlreadyExists_',
    "Email" = '_UserEmailAlreadyExists_'
}